import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { srOnly } from '../styles/composables.css.js';

/**
 * A thin wrapper around a native `<label>` element.
 */
const LabelPrimitive = forwardRef((props, ref) => (jsx("label", { "data-fpl-component": "primitive", ...props, ref: ref })));
LabelPrimitive.displayName = 'LabelPrimitive';
/**
 * A thin wrapper around a native `<label>` element that also hides the label from sighted users.
 */
const HiddenLabelPrimitive = forwardRef((props, ref) => jsx(LabelPrimitive, { ...props, className: srOnly, ref: ref }));
HiddenLabelPrimitive.displayName = 'HiddenLabelPrimitive';
/**
 * A thin wrapper around a native `<legend>` element.
 */
const LegendPrimitive = forwardRef((props, ref) => (jsx("legend", { "data-fpl-component": "primitive", ...props, ref: ref })));
LegendPrimitive.displayName = 'LegendPrimitive';
/**
 * A thin wrapper around a native `<legend>` element that also hides the legend from sighted users.
 */
const HiddenLegendPrimitive = forwardRef((props, ref) => jsx(LegendPrimitive, { ...props, className: srOnly, ref: ref }));
HiddenLegendPrimitive.displayName = 'HiddenLegendPrimitive';

export { HiddenLabelPrimitive, HiddenLegendPrimitive, LabelPrimitive, LegendPrimitive };
//# sourceMappingURL=label-primitive.js.map
